import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const CurrencyCtx = createContext(null);

const SYMBOLS = { INR: "₹", AED: "AED ", EUR: "€" };
const FALLBACK = { base: "INR", rates: { INR: 1, AED: 0.043, EUR: 0.011 } };
// Approx conversion factors from AED (kept aligned with typical mid-market rates)
const AED_TO = { AED: 1, INR: 23.25, EUR: 0.25 };

export function CurrencyProvider({ children }) {
  const [config, setConfig] = useState(FALLBACK);
  const [currency, setCurrency] = useState(() => localStorage.getItem("maxine_currency") || "INR");

  useEffect(() => {
    api.get("/currency").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    localStorage.setItem("maxine_currency", currency);
  }, [currency]);

  const format = useCallback(
    (inrAmount) => {
      const rate = config?.rates?.[currency] ?? FALLBACK.rates[currency] ?? 1;
      const converted = Number(inrAmount) * rate;
      const sym = SYMBOLS[currency] || "";
      // whole numbers for INR, 2 decimals otherwise
      const digits = currency === "INR" ? 0 : converted < 100 ? 2 : 0;
      const num = converted.toLocaleString(currency === "INR" ? "en-IN" : "en-US", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      });
      return `${sym}${num}`;
    },
    [config, currency]
  );

  const formatFromAED = useCallback(
    (aedAmount) => {
      const factor = AED_TO[currency] ?? 1;
      const converted = Number(aedAmount) * factor;
      const sym = SYMBOLS[currency] || "";
      const num = converted.toLocaleString(currency === "INR" ? "en-IN" : "en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return `${sym}${num}`;
    },
    [currency]
  );

  return (
    <CurrencyCtx.Provider value={{ currency, setCurrency, config, format, formatFromAED }}>{children}</CurrencyCtx.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyCtx);
